import { ApplicationRoutes } from "../../routes";
import { MenuItemData } from "../menu.types";
import {
	SettingsIcon,
	VendingIcon,
	VendingActiveIcon,
	SettingsActiveIcon,
	PostpaidIcon,
	PostpaidActiveIcon,
	BillsDashboardIcon,
	BillsDashboardActiveIcon,
	BulkPurchaseIcon,
	BulkPurchaseInactiveIcon,
} from "../../assets/icons";
import {
	ApplianceActiveMenuIcon,
	ApplianceItemActiveIcon,
	ApplianceItemIcon,
	ApplianceMenuIcon,
	CategoryActiveIcon,
	CategoryIcon,
	CustomerMenuActiveIcon,
	CustomerMenuIcon,
	LoanProductsMenuActiveIcon,
	LoanProductsMenuIcon,
	LoanRequestMenuActiveIcon,
	LoanRequestMenuIcon,
	LoanSummaryMenuActiveIcon,
	LoanSummaryMenuIcon,
	PotentialLeadsMenuActiveIcon,
	PotentialLeadsMenuIcon,
	RoofTypeActiveIcon,
	RoofTypeIcon,
	SolarProviderMenuActiveIcon,
	SolarProviderMenuIcon,
	StoreBannerActiveIcon,
	StoreBannerIcon,
	UtilAdminSettingsMenuActiveIcon,
	UtilAdminSettingsMenuIcon,
} from "../../assets/sidemenu-icons";

export const MENU_STRUCTURE = {
	bills: [
		{
			text: "Home",
			icon: <BillsDashboardIcon />,
			isActiveIcon: <BillsDashboardActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.ADMIN_BILLS}/${ApplicationRoutes.DASHBOARD}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Vending History",
			icon: <VendingIcon />,
			isActiveIcon: <VendingActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.ADMIN_BILLS}/${ApplicationRoutes.VENDING_HISTORY}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Postpaid History",
			icon: <PostpaidIcon />,
			isActiveIcon: <PostpaidActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.ADMIN_BILLS}/${ApplicationRoutes.POSTPAID_HISTORY}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Bulk Purchase",
			icon: <BulkPurchaseInactiveIcon />,
			isActiveIcon: <BulkPurchaseIcon />,
			route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.ADMIN_BILLS}/${ApplicationRoutes.BULK_PURCHASE}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Settings",
			icon: <SettingsIcon color="#17171780" height={26} width={26} />,
			isActiveIcon: <SettingsActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.ADMIN_BILLS}/${ApplicationRoutes.SETTINGS}`,
			subMenuItems: [],
			disabled: false,
		},
	] as MenuItemData[],
	marketplace: [
		{
			text: "Dashboard",
			icon: <VendingIcon />,
			isActiveIcon: <VendingActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.SOLAR_MARKET}/${ApplicationRoutes.DASHBOARD}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Solar Provider",
			icon: <SolarProviderMenuIcon />,
			isActiveIcon: <SolarProviderMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.SOLAR_MARKET}/${ApplicationRoutes.SOLAR_PROVIDER}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Customer",
			icon: <CustomerMenuIcon />,
			isActiveIcon: <CustomerMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.SOLAR_MARKET}/${ApplicationRoutes.CUSTOMER_BASE}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Appliance",
			icon: <ApplianceMenuIcon />,
			isActiveIcon: <ApplianceActiveMenuIcon />,
			route: null, // Main menu doesn't have a direct route
			subMenuItems: [
				{
					route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.SOLAR_MARKET}/${ApplicationRoutes.APPLIANCE_CATEGORIES}`,
					text: "Category",
					icon: <CategoryIcon />,
					isActiveIcon: <CategoryActiveIcon />,
				},
				{
					route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.SOLAR_MARKET}/${ApplicationRoutes.SEARCH_PARAMETER}`,
					text: "Item",
					icon: <ApplianceItemIcon />,
					isActiveIcon: <ApplianceItemActiveIcon />,
				},
			],
			disabled: false,
		},
		{
			text: "Loan Summary Page",
			icon: <LoanSummaryMenuIcon />,
			isActiveIcon: <LoanSummaryMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.SOLAR_MARKET}/${ApplicationRoutes.LOAN_SUMMARY}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Loan Product Page",
			icon: <LoanProductsMenuIcon />,
			isActiveIcon: <LoanProductsMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.SOLAR_MARKET}/${ApplicationRoutes.LOAN_PRODUCTS}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Loan Request Page",
			icon: <LoanRequestMenuIcon />,
			isActiveIcon: <LoanRequestMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.SOLAR_MARKET}/${ApplicationRoutes.LOAN_REQUEST}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Potential Leads",
			icon: <PotentialLeadsMenuIcon />,
			isActiveIcon: <PotentialLeadsMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.SOLAR_MARKET}/${ApplicationRoutes.LEADS}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Settings",
			icon: <SettingsIcon color="#17171780" height={26} width={26} />,
			isActiveIcon: <SettingsActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.SOLAR_MARKET}/${ApplicationRoutes.SETTINGS}`,
			subMenuItems: [
				{
					text: "Product Category",
					route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.SOLAR_MARKET}/${ApplicationRoutes.PRODUCTS_CATEGORY}`,
					icon: <ApplianceItemIcon />,
					isActiveIcon: <ApplianceItemActiveIcon />,
				},
				{
					text: "Roof Type",
					route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.SOLAR_MARKET}/${ApplicationRoutes.ROOF_TYPE}`,
					icon: <RoofTypeIcon />,
					isActiveIcon: <RoofTypeActiveIcon />,
				},
				{
					text: "Store Banner",
					route: `/${ApplicationRoutes.ADMIN_BASE}/${ApplicationRoutes.SOLAR_MARKET}/${ApplicationRoutes.ADVERT_BANNER}`,
					icon: <StoreBannerIcon />,
					isActiveIcon: <StoreBannerActiveIcon />,
				},
			],
			disabled: false,
		},
	] as MenuItemData[],
};
